import React from 'react';
import { Box, ButtonBase, Stack, Typography, alpha } from '@mui/material';

const toneColor = (theme, tone) =>
  (tone === 'default' ? theme.palette.grey[600] : theme.palette[tone].main);

const Tile = ({ label, count, tone, selected, onClick, hint }) => (
  <ButtonBase
    onClick={onClick}
    sx={(theme) => {
      const color = toneColor(theme, tone);
      return {
        flex: '1 1 150px',
        minWidth: 138,
        px: 1.75,
        py: 1.25,
        borderRadius: 2.5,
        textAlign: 'left',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        border: '1px solid',
        borderColor: selected ? color : 'divider',
        backgroundColor: selected ? alpha(color, 0.12) : '#fff',
        boxShadow: selected ? `inset 0 0 0 1px ${color}` : 'none',
        transition: 'all 140ms ease',
        '&:hover': {
          borderColor: color,
          backgroundColor: alpha(color, selected ? 0.16 : 0.06),
        },
      };
    }}
  >
    <Box sx={{ width: '100%' }}>
      <Typography
        variant="h5"
        sx={(theme) => ({ fontWeight: 800, lineHeight: 1.1, color: toneColor(theme, tone) })}
      >
        {count.toLocaleString()}
      </Typography>
      <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.primary' }}>
        {label}
      </Typography>
      {hint ? (
        <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
          {hint}
        </Typography>
      ) : null}
    </Box>
  </ButtonBase>
);

const ReportTriageStrip = ({ buckets, total, selected, onToggle, onShowAll, dateLabel }) => (
  <Stack direction="row" spacing={1.25} sx={{ flexWrap: 'wrap', gap: 1.25, mb: 2 }}>
    <Tile
      label="All rows"
      hint={dateLabel}
      count={total}
      tone="default"
      selected={selected.length === 0}
      onClick={onShowAll}
    />
    {buckets.map((bucket) => (
      <Tile
        key={bucket.id}
        label={bucket.label}
        count={bucket.count}
        tone={bucket.tone}
        selected={selected.includes(bucket.id)}
        onClick={() => onToggle(bucket.id)}
      />
    ))}
  </Stack>
);

export default ReportTriageStrip;
